/**
 * @description 导出默认通用配置
 */
const setting = {
  // 开发以及部署时的URL
  publicPath: process.env.VUE_APP_PUBLIC_PATH,
  // 生产环境构建文件的目录名
  outputDir: 'dist',
  // 放置生成的静态资源 (js、css、img、fonts) 的 (相对于 outputDir 的) 目录。
  assetsDir: '',
  // 默认的接口地址 如果是开发环境和生产环境走mock-server，当然你也可以选择自己配置成需要的接口地址
  baseURL: '',
  //标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
  title: 'Transsion BPM',
  //版本号
  version: process.env.VUE_APP_VERSION,
  // 路由模式，可选值为 history 或 hash
  routerMode: 'history',
  //不经过token校验的路由
  routesWhiteList: ['/404', '/401', '/500'],
  //加载时显示文字
  loadingText: '正在加载中...',
  //vertical布局时是否只保持一个子菜单的展开
  uniqueOpened: true,
  //vertical布局时默认展开的菜单path，使用逗号隔开建议只展开一个
  defaultOpens: ['/index'],
  //需要加loading层的请求，防止重复提交
  debounce: ['doEdit'],
  //以全屏打开页面的url地址参数
  fullScreenKey: '__isFull__',
  //来源系统参数
  sourceSystemKey: '__sourceSystem__',
  // 数据权限参数
  rolePermissionKey: 'rolePermission',
  // 是否在新tab中打开流程表单页面
  isOpenUrlInNewTab: false,
  // templatePreview是否保持keepalive（注意：改配置设置为true时，
  // vue-router会报警告，因为所有注册组件为TemplatePreview的路由都会设置为相同的name，路由的跳转不能使用name来跳转，只能使用path跳转）
  templatePreviewKeepalive: true,
  // querySqlPreview是否保持keepalive（注意：改配置设置为true时，
  // vue-router会报警告，因为所有注册组件为QuerySqlPreview的路由都会设置为相同的name，路由的跳转不能使用name来跳转，只能使用path跳转）
  querySqlPreviewKeepalive: true,
}

module.exports = setting
